module.exports = __webpack_public_path__ + "static/media/general secretary.1ab4e6fe.jpg";